//make sure to clear password from state after submit AND in unmount
import React, { Fragment } from 'react'
import { HelpBlock, FormControl, Button } from 'react-bootstrap'
import EnrolmentForm from './enrollmentForm'
import { getParams, end_point, validateEmail } from './helper'
import Footer from './footer'
import LeagueEnrolment from './leagueEnrolment'
import axios from 'axios'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

var $ = require('jquery');

class Login extends React.Component {
  constructor(props) {
    super(props);
    var params = getParams();
    this.emailInput = null;
    this.state = {
      mode: params.reset === 'true' ? 'passwordReset' : 'email',
      endpoint: `${end_point('users')}/login`,
      email: '',
      password: '',
      passwordConfirm: '',
      passwordValid: false,
      error: null,
      showPassword: false,
      showPasswordConfirm: false,
      organization_id: params.organization_id,
      organization_name: params.organization_name
        ? params.organization_name.replace(/%20/g, " ").replace(/%27/g, "'")
        : localStorage.getItem('organization_name'),
      organization_logo: localStorage.getItem('organization_logo'),
      loading: false,
      redirectedUser: params.redirectedUser,
      league: params.extLeague,
      search: params.search,
      EF1: params.EF1
    };
  }

  componentDidMount() {

    var orgName = getParams().organization_name ? getParams().organization_name.replace(/%20/g, " ").replace(/%27/g, "'"): null
    var orgID = getParams().organization_id ? getParams().organization_id : null
    
    if (!orgName && orgID) {
      this.findOrgName(orgID)
    }

    if (this.state.mode === 'email' && this.emailInput) {
      this.emailInput.focus()
    }
  }

  findOrgName = async (orgID) => {
    const { organization_name } = this.state
    var name = null
    if (!organization_name && orgID) {
      const response = await axios.get(`${end_point('organizations')}/organizations`, {
        headers: {
          "token": "login",
          "organization_id": orgID
        },
      }).then(response => {
        console.log('find org name', response.data)
        name = response.data
        this.setState({organization_name: response.data})
      })
    }
    return name
  }

  submitEmail = () => {
    var rthis = this;
    var email = document.getElementsByName('email')[0].value.toLowerCase()
    var validate = validateEmail(email);
    if(validate){
      this.setState({'loading': true});
      $.ajax({
        url: this.state.endpoint,
        type: 'GET',
        dataType: 'json',
        headers: {
          'function': 'check_email_exists',
          'email': email,
          'organization_id': this.state.organization_id,
          'league': this.state.league
        },
        success: async (data) => {
          console.log("check_email_exists", data)
          if (data.errorMessage) {
            rthis.setState({ error: `${data.errorMessage}`, loading: false });
          } else {
            if(data.message === false && rthis.state.organization_id === undefined && !rthis.state.EF1){
              alert('Oops! This is the login page for administrators.  Please sign-in through an organization')
              email = ''
              rthis.setState({ loading: false })

            } else {
              var orgName = await rthis.findOrgName(data.message[0])
              console.log('come back from submitEmail', data.message)
              var mode = data.message ? 'login' : 'passwords';
              if (data.message[0]) {
                rthis.setState({ organization_id: data.message[0] })
                if (orgName || rthis.state.organization_name) {
                  rthis.setState({ 
                    email, 
                    mode: mode, 
                    loading: false
                  })
                }
              } else {
                rthis.setState({ 
                  email, 
                  mode: mode,
                  loading: false
                })
              }
            }
          }
        },
        error: function (data){
          alert('Please contact support info@hoostir.com');
        }
      });
    } else {
      alert('Please enter a valid email address')
    }
  }

  submitLogin = () => {
    var rthis = this;
    console.log('submit login - org?', this.state.organization_id)
    if (document.getElementsByName('password')[0].value !== "") {
      this.setState({ 'loading': true })
      $.ajax({
        url: this.state.endpoint,
        type: 'GET',
        dataType: 'json',
        headers: {
          'function': 'check_password_correct',
          'email': this.state.email,
          'password': document.getElementsByName('password')[0].value,
          'organization_id': this.state.organization_id
        },
        success: (data) => {
          localStorage.setItem('parent_email', rthis.state.email);
          if (!data.errorMessage) {
            localStorage.setItem('jwt', data.message);
            if (rthis.state.isEnrolling) {
              console.log('post submit login - is enrolling, set mode - league??', rthis.state.league)
              rthis.setState({ 'mode': 'enrollmentForm', 'token': data.message, 'loading': false });
            } else if (rthis.state.redirectedUser){
              console.log('post submit login - redirectedUser , set mode - league??', rthis.state.league)
              if (rthis.state.league) {
                console.log('post submit login', data.message)
                rthis.setState({ 'mode': 'enrollmentForm', 'token': data.message, 'loading': false });
              } else {
                var temp_url = window.location.href + '&jwt=' + data.message
                temp_url = temp_url.replace(/login/g, 'enrollmentform')
                window.location.href = temp_url;
              }
            } else {
              console.log('sending to portal dashboard - post submit login - orgid?', rthis.state.organization_id )
              window.location.href = document.location.origin + '/portals?jwt=' + data.message + (rthis.state.organization_id ? ('&organization_id=' + rthis.state.organization_id) : '');
            }
          } else {
            alert('incorrect password');
            rthis.setState({ loading: false }, () => {
              document.getElementsByName('password')[0].value = null;
            })
          }
        },
        error: (data) => {
          alert('incorrect password');
          if(rthis.state.redirectedUser || rthis.state.organization_id){
            rthis.setState({ 
              loading: false,
              mode: 'login'}, () => {
              document.getElementsByName('password')[0].value = null;
            })
          } else {
            window.location.href = document.location.origin + '/login';
          }
        }
      });
    } else {
      alert('Please enter a password.')
    }
  }

  submitPasswords = () => {
    const length = this.state.password.length;
    if (length >= 5 && 20 > length && this.state.password === this.state.passwordConfirm) {
      localStorage.setItem('password', this.state.password)
      this.setState({ mode: 'enrollmentForm' });
    } else {
      if (length < 5) {
        alert('Password must be 5 or more characters.')
      }
      if (length > 20) {
        alert('Password must be less than 21 characters.')
      }
      if (this.state.password !== this.state.passwordConfirm) {
        alert("The passwords do not match.")
      }
    }
  }

  submitPasswordReset = () => {
    this.setState({ loading: true })
    var rthis = this
    const length = this.state.password.length
    if (length >= 5 && 20 > length && this.state.password === this.state.passwordConfirm) {
      $.ajax({
        url: this.state.endpoint,
        type: 'GET',
        dataType: 'json',
        headers: {
          'function': 'new_password',
          'token': getParams().jwt,
          'password': this.state.password
        },
        success: function (data) {
          rthis.setState({ loading: false })
          if (data.errorMessage) {
            alert('This password cannot be reset at this time.  Please contact support info@hoopstir.com or try again in a few minutes.  Thank you.')
            window.location.href = document.location.origin + '/login';
          }
          else {
            if(data.message.updated === true){
              alert('Password Updated, please log in with your password')
              window.location.href = document.location.origin + '/login?organization_id=' + rthis.state.organization_id
            } else {
              alert('This password cannot be reset at this time.  Please contact support info@hoopstir.com or try again in a few minutes.  Thank you.')
              window.location.href = document.location.origin + '/login';
            }
          }
        },
        error: function(data) {
          rthis.setState({ loading: false })
          alert('This password cannot be reset at this time.  Please contact support info@hoopstir.com or try again in a few minutes.  Thank you.');
          window.location.href = document.location.origin + '/login';
        }
      });
    } else {
      alert('Please confirm your password')
    }
  }

  checkForEnterEmail = (target) => {
    if (target.charCode === 13) {
      target.preventDefault();
      this.submitEmail();
    }
  }

  checkForEnterLogin = (target) => {
    if (target.charCode === 13) {
      target.preventDefault();
      this.submitLogin();
    }
  }

  checkForEnterPasswords = (target) => {
    if (target.charCode === 13) {
      target.preventDefault();
      this.submitPasswords();
    }
  }

  checkForEnterPasswordReset = (target) => {
    if (target.charCode === 13) {
      target.preventDefault();
      this.submitPasswordReset();
    }
  }

  validationPassword() {
    const length = this.state.password.length;
    if (length > 20) return 'error';
    else if (length >= 5) return 'success';
    //else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
    return null;
  }

  validationPasswordConfirm() {
    const length = this.state.password.length;
    if (length >= 5 && 20 > length && this.state.password === this.state.passwordConfirm) {
      return 'success';
    } else if (this.state.password !== this.state.passwordConfirm) {
      return 'error';
    }
    return null;
  }

  getPasswordFieldClassName = () => {
    return this.validationPasswordConfirm() === 'error'
      ? 'login-fields login-fields-error'
      : 'login-fields'
  }

  handleChange = (field, e) => {
    this.setState({[field] : e.target.value })
  }

  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field]
    }))
  }

  passwordReset = () => {
    this.setState({ mode: 'reset' });
  }

  submitEmailForReset = () => {
    console.log('in submitEmailForReset')
    this.setState({loading: true})
    var rthis = this;
    if(this.state.organization_id){
      $.ajax({
        url: this.state.endpoint,
        type: 'GET',
        dataType: 'json',
        headers: {
          'function': 'reset_password',
          'email': document.getElementsByName('email')[0].value.toLowerCase(),
          'organization_id': rthis.state.organization_id
        },
        success: function (data) {
          rthis.setState({loading: false})
          if (data.errorMessage) {
            //error state
            alert('Error')
            window.location.href = document.location.origin + '/login';
          }
          else {
            if(data.message === true){
              alert('An email has been sent to reset your password.')
              window.location.href = document.location.origin + `/login?organization_id=${rthis.state.organization_id}`;
            } else {
              alert('There is no account connected to this email.')
              window.location.href = document.location.origin + `/login?organization_id=${rthis.state.organization_id}`;
            }
          }
        },
        error: function(data) {
          rthis.setState({loading: false})
          alert('There is no account connected to this email.');
          window.location.href = document.location.origin + `/login?organization_id=${rthis.state.organization_id}`;
        }
      });
    } else {
      alert("Please sign in through an Organization's login page.")
    }
  }

  checkForEnterEmailReset = (target) => {
    if (target.charCode === 13) {
      target.preventDefault();
      this.submitEmailForReset();
    }
  }

  releaseLockedEmail = () => {
      this.setState({ mode: 'email' }, () => {
      document.getElementsByName('email')[0].value = this.state.email;
      if (this.emailInput) {
        this.emailInput.focus()
      }
    })
  }

  render() {
    var rthis = this;
    var content = null;
    var loadingSpinner = null;
    var logo_url = `https://s3.amazonaws.com/hoop-organization-logo/${this.state.organization_id}_logo`
    
    const { mode, token, organization_name, EF1, organization_logo } = this.state
    
    const loginBanner = (fields) => {
      const logo = organization_logo || (this.state.organization_id ? logo_url : null)
      return (
        <div className="login-shell" data-testid="login-banner">
          <div className="login-card">
            <div className="login-brand login-logo-slot">
              {logo ? <img className="login-logo login-logo-image" src={logo} alt="logo" /> : null}
            </div>
            <div className="login-content">
              {fields}
            </div>
            <Footer login={true}/>
          </div>
        </div>
      );
    }

    // ------ ENTER YOUR EMAIL ------ //

    const emailFields = () => {
      return (
        loginBanner(
 
          <div className="loginform">
            {/* <h2>Welcome to {organization_name ? decodeURIComponent(organization_name): 'Hoopstir'}</h2> */}
          <div className="login-field-group">
            <label className="login-label" htmlFor="email">Email</label>
            <FormControl className="login-fields" inputRef={ref => { this.emailInput = ref; }} autoFocus name="email" type="text" id="email" onKeyPress={rthis.checkForEnterEmail} placeholder="" data-testid="email" value={rthis.state.email || ''} onChange={e => rthis.handleChange('email', e)} />
          </div>           

          <div className="login-error">{error_message}</div>

          <Button className="login-primary-button" type="button" tabIndex={0} onClick={rthis.submitEmail} data-testid="email-submit">Submit</Button>

            {loadingSpinner}
          </div>       

      ))
    }

    // ------ SET YOUR PASSWORD ------ //
    
    const passwordFields = () => {
      return (
      loginBanner(
  
        <div className="loginform">
          <div className="login-field-group" style={{marginTop: "0px"}}>
            <label className="login-label" htmlFor="password-email">Email</label>
            <FormControl readOnly className="login-fields" type="text" onClick={rthis.releaseLockedEmail} value={rthis.state.email || ''} />
          </div>
      
          <div className="login-field-group">
            <label className="login-label" htmlFor="password">Password</label>
            <div className="login-password-field">
              <FormControl className={rthis.getPasswordFieldClassName()} autoFocus name="password" type={rthis.state.showPassword ? 'text' : 'password'} value={rthis.state.password} placeholder="" onChange={e => rthis.handleChange('password', e)} />
              <button type="button" className="login-password-toggle" aria-label={rthis.state.showPassword ? 'Hide password' : 'Show password'} onClick={() => rthis.togglePasswordVisibility('showPassword')}>
                <FontAwesomeIcon icon={rthis.state.showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
            <HelpBlock className="login-help">Between 5-20 characters</HelpBlock>
          </div>
      
          <div className="login-field-group">
            <label className="login-label" htmlFor="passwordConfirm">Confirm Password</label>
            <div className="login-password-field">
              <FormControl className={rthis.getPasswordFieldClassName()} name="passwordConfirm" type={rthis.state.showPasswordConfirm ? 'text' : 'password'} value={rthis.state.passwordConfirm} placeholder="" onChange={e => rthis.handleChange('passwordConfirm', e)} onKeyPress={rthis.checkForEnterPasswords} />
              <button type="button" className="login-password-toggle" aria-label={rthis.state.showPasswordConfirm ? 'Hide password confirmation' : 'Show password confirmation'} onClick={() => rthis.togglePasswordVisibility('showPasswordConfirm')}>
                <FontAwesomeIcon icon={rthis.state.showPasswordConfirm ? faEyeSlash : faEye} />
              </button>
            </div>
            <HelpBlock className="login-help">Between 5-20 characters</HelpBlock>
          </div>
  
          <div className="login-note">
            <a className="login-secondary-link" href={document.location.origin + `/privacy?organization_id=${rthis.state.organization_id}`} >Click Submit to accept Privacy and Terms</a>
          </div>          
      
          <Button className="login-primary-button" type="button" onClick={rthis.submitPasswords}>Submit</Button>                  
          {/* <span style={{fontSize: '10px'}}>I accept <a style={{color: 'white', textDecoration:'underline'}} href={document.location.origin + `/privacy?organization_id=${rthis.state.organization_id}`}>Privacy and Terms</a></span>             */}
        
        </div>
      )
      )
      }

    // ------ RETURNING USER LOGGING IN TO ORG PAGE ------ //

    const loginFields = orgName => {
      return (
        loginBanner(

          <div className="loginform">
              {/* <h2>Welcome back to {orgName ? `to ${orgName}`: "back!"}</h2> */}

            <div className="login-field-group">
              <label className="login-label" htmlFor="login-email">Email</label>
              <FormControl readOnly className="login-fields" type="text" onClick={rthis.releaseLockedEmail} value={rthis.state.email || ''} />
            </div>
            <div className="login-field-group">
            <label className="login-label" htmlFor="login-password">Password</label>
              <FormControl autoFocus placeholder="Password" className="login-fields" name="password" type="password" onKeyPress={rthis.checkForEnterLogin} onChange={e => rthis.handleChange('password', e)} value={rthis.state.password} id="password" />
            </div>
            <Button className="login-primary-button" type="button" onClick={rthis.submitLogin}>Sign in</Button>
            <a className="login-secondary-link" onClick={rthis.passwordReset}>Forgot password?</a>
              {loadingSpinner}

            </div>        
           
          
        )
      )
    }

          // ------ REQUESTING A PASSWORD RESET FORM ------- //

          const resetPassword = () => {
            return (
              loginBanner(
      
                <div className="loginform">        
                <div className="login-field-group">
                 <label className="login-label" htmlFor="reset-email">Email</label>            
                  <FormControl className="login-fields" inputRef={ref => { this.emailInput = ref; }} autoFocus name="email" type="text" id="email" placeholder="" onKeyPress={rthis.checkForEnterEmailReset} value={rthis.state.email || ''} onChange={e => rthis.handleChange('email', e)}/>
                  </div>
                    <Button className="login-primary-button" type="button" onClick={rthis.submitEmailForReset}>Send Reset Email</Button>
                    <a className="login-secondary-link" type="button" onClick={rthis.submitEmail} data-testid="email-submit">Cancel</a>


      
                  {loadingSpinner}
      
                </div>          
            ))
          }

      // ------ RESETTING PASSWORD FORM ------- //

      const passwordReset = () => {
        return (
          loginBanner(
  
            <div className="loginform">
                <h2 className="login-section-title">Set New Password</h2>
                <p className="login-section-copy">Choose a password that is easy to remember and hard to guess.</p>
              <div className="login-field-group">
                <label className="login-label" htmlFor="reset-password">Password</label>
                <div className="login-password-field">
                  <FormControl className={rthis.getPasswordFieldClassName()} autoFocus name="password" type={rthis.state.showPassword ? 'text' : 'password'} value={rthis.state.password} placeholder="Set new password" onChange={e => rthis.handleChange('password', e)} />
                  <button type="button" className="login-password-toggle" aria-label={rthis.state.showPassword ? 'Hide password' : 'Show password'} onClick={() => rthis.togglePasswordVisibility('showPassword')}>
                    <FontAwesomeIcon icon={rthis.state.showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                <FormControl.Feedback />
                <HelpBlock className="login-help">5-20 characters are required</HelpBlock>
              </div>
  
              <div className="login-field-group">
                <label className="login-label" htmlFor="reset-password-confirm">Confirm Password</label>
                <div className="login-password-field">
                  <FormControl className={rthis.getPasswordFieldClassName()} name="passwordConfirm" type={rthis.state.showPasswordConfirm ? 'text' : 'password'} value={rthis.state.passwordConfirm} placeholder="Confirm new password" onChange={e => rthis.handleChange('passwordConfirm', e)} onKeyPress={rthis.checkForEnterPasswordReset} />
                  <button type="button" className="login-password-toggle" aria-label={rthis.state.showPasswordConfirm ? 'Hide password confirmation' : 'Show password confirmation'} onClick={() => rthis.togglePasswordVisibility('showPasswordConfirm')}>
                    <FontAwesomeIcon icon={rthis.state.showPasswordConfirm ? faEyeSlash : faEye} />
                  </button>
                </div>
                <FormControl.Feedback />            
              </div>
              <Button className="login-primary-button" type="button" onClick={rthis.submitPasswordReset}>Submit</Button>

            {loadingSpinner}
  
           </div>           
          )
        )
      }

    loadingSpinner = (
      <div className="login-spinner-slot" aria-live="polite" aria-busy={this.state.loading}>
        {this.state.loading ? <div className="loader"></div> : null}
      </div>
    )

    if (mode === 'email') {
      var error_message = null;
      if (this.state.error) {
        error_message = this.state.error;
      }
      content = (emailFields())
    } else if (mode === 'login') {
      content = (loginFields(organization_name))
    } else if (mode === 'passwords') {
      content = (passwordFields())
    } else if (mode === 'reset') {
      content = (resetPassword())
    } else if (mode === 'passwordReset') {
      content = (passwordReset())
    } else if (mode === 'enrollmentForm') {
      // TODO: Line below should be influenced by organization's flag (whether to use Stripe or Converge payment gateway)
      // let useStripe = true;
      console.log('in statemode === enrollmentForm - league?', this.state.league)
      if(this.state.redirectedUser){
        if (EF1) {
          content = (
            <LeagueEnrolment email={this.state.email} password={this.state.password} token={token} club_id={this.state.organization_id} EF1={EF1} allowSelectPrograms={true} />
          )
        } else {
          content = (
            <EnrolmentForm email={this.state.email} password={this.state.password} token={token} />
          )
        }
      } else {
        content = (
        <EnrolmentForm email={this.state.email} password={this.state.password} token={token}  search={this.state.search} />)
      }
    }
    
    return (
      <div>
        {content}
      </div>
    )
  }
}

export default Login;
